import { useParams } from 'react-router-dom';
import { TeamAccessGuard, RoleGuard } from '@/components/auth';
import InviteUserForm from '@/components/teams/InviteUserForm';
import BulkInviteForm from '@/components/teams/BulkInviteForm';
import InvitationsList from '@/components/teams/InvitationsList';
import { Alert } from '@/components/common';

export default function TeamInvitePage() {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { teamId: _ } = useParams<{ teamId: string }>();
  
  // Create a fallback component for non-admin users
  const nonAdminFallback = (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <Alert variant="error">
        You need administrator privileges to invite team members.
      </Alert>
    </div>
  );
  
  return (
    <TeamAccessGuard>
      <RoleGuard roles={['admin']} fallback={nonAdminFallback}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <h1 className="text-3xl font-bold mb-6">Invite Team Members</h1>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
            <InviteUserForm />
            <BulkInviteForm />
          </div>
          
          <InvitationsList />
        </div>
      </RoleGuard>
    </TeamAccessGuard>
  );
} 